// Signals which resources the AI agent has modified and pages should silently re-fetch.
// Counter increments on each refresh so useSelector triggers even when resources are the same.
const initialState: { resources: string[]; tick: number } = { resources: [], tick: 0 };

const agentRefreshReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "AGENT_REFRESH":
      return { resources: action.payload, tick: state.tick + 1 };
    default:
      return state;
  }
};

export default agentRefreshReducer;
